import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { matchRoute } from './routes';
import { buildSchema } from './schema';
import { subscribeSeoOverride, type SeoOverride } from './seoStore';

const SCRIPT_ID = 'luvira-structured-data';

/**
 * Keeps exactly one managed JSON-LD <script> in the document head and rebuilds
 * it on route change. Kept separate from the runtime Open Graph / Twitter tag
 * manager in SeoManager.
 */
export default function SchemaJsonLd() {
  const { pathname } = useLocation();
  const [override, setOverride] = useState<SeoOverride | null>(null);

  useEffect(() => subscribeSeoOverride(setOverride), []);

  useEffect(() => {
    const route = matchRoute(pathname);
    const graph = buildSchema(route, pathname, override);

    if (graph.length === 0) {
      document.getElementById(SCRIPT_ID)?.remove();
      return;
    }

    let script = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@graph': graph,
    });
  }, [pathname, override]);

  return null;
}